<div
  class="bg-white rounded-md drop-shadow-md bg-no-repeat bg-right"
  style="background-image: url('assets/images/backgrounds/bg-info.svg')"
>
  <div class="py-4 px-6">
    <ng-content></ng-content>
  </div>
</div>
